import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // token:
    //   "/R3e+NxwvpKoouQydwPtLZ+Y14cUB+xvUJeijvfqc2HSJyXbEqj+vzJdrHNr05Vj/Z7lzcBs0AgBzI4M/169XQ==",
    token: "",
    openId: ""
  },
  mutations: {
    setOpenId(state, openId) {
      state.openId = openId;
    },
    setToken(state, token) {
      state.token = token;
    }
  },
  actions: {},
  modules: {}
});
